import userInfo from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
export const useGates = () => {
  const [userData, setUserData] = useState({});
  useEffect(() => {
    userInfo().then(response => {
      setUserData(response);
    }).catch(() => {
      setUserData(Object.assign({}, {}, {
        gates: []
      }));
    });
  }, []);
  return {
    gates: userData.gates
  };
};